import type { PokemonV2 } from '../../pokemon/pokemon';
import type { EffectiveValue } from '../../types/damage';
import {
  calcRealValueHPStat,
  calcRealValueAttackDefencePokemon,
  calcRealValueDeffenceDefencePokemon,
  calcRealValueSpecialAttackDefencePokemon,
  calcRealValueSpecialDeffenceDefencePokemon,
  calcRealValueSpeedDefencePokemon,
  calcRealValueAttackOffencePokemon,
  calcRealValueDeffenceOffencePokemon,
  calcRealValueSpecialAttackOffencePokemon,
  calcRealValueSpecialDeffenceOffencePokemon,
  calcRealValueSpeedOffencePokemon,
} from '../stat/real-value';

// 実値計算のキャッシュ（攻守共通）
const statCache = new Map<string, EffectiveValue>();

export function calcOffenceEffectiveValueCached(pokemon: PokemonV2): EffectiveValue {
  // 影響するパラメータのみをキーにして実値をキャッシュする
  const cacheKey = JSON.stringify({
    id: pokemon.id,
    effective_slider_step: pokemon.effective_slider_step,
    personality: pokemon.personality,
    rankCorrection: pokemon.rankCorrection,
    selected_ability_id: pokemon.selected_ability_id,
    selected_ability: pokemon.selected_ability,
    selected_item_id: pokemon.selected_item_id,
    terasu_type: pokemon.terasu_type,
    selected_move_id: pokemon.selected_move?.id,
    individualValue: pokemon.individualValue,
    // 攻守で同じ条件でも衝突しないように区別する
    type: 'offence',
  });

  const cached = statCache.get(cacheKey);
  if (cached) return cached;

  const effectiveValue: EffectiveValue = {
    hp: calcRealValueHPStat(pokemon),
    attack: calcRealValueAttackOffencePokemon(pokemon),
    defense: calcRealValueDeffenceOffencePokemon(pokemon),
    special_attack: calcRealValueSpecialAttackOffencePokemon(pokemon),
    special_defense: calcRealValueSpecialDeffenceOffencePokemon(pokemon),
    speed: calcRealValueSpeedOffencePokemon(pokemon),
  };

  statCache.set(cacheKey, effectiveValue);
  return effectiveValue;
}

export function calcDefenceEffectiveValueCached(pokemon: PokemonV2): EffectiveValue {
  // 防御側は攻撃側と別キーにして衝突を避ける
  const cacheKey = JSON.stringify({
    id: pokemon.id,
    effective_slider_step: pokemon.effective_slider_step,
    personality: pokemon.personality,
    rankCorrection: pokemon.rankCorrection,
    selected_ability_id: pokemon.selected_ability_id,
    selected_ability: pokemon.selected_ability,
    selected_item_id: pokemon.selected_item_id,
    terasu_type: pokemon.terasu_type,
    individualValue: pokemon.individualValue,
    // 攻守で同じ条件でも衝突しないように区別する
    type: 'defence',
  });

  const cached = statCache.get(cacheKey);
  if (cached) return cached;

  const effectiveValue: EffectiveValue = {
    hp: calcRealValueHPStat(pokemon),
    attack: calcRealValueAttackDefencePokemon(pokemon),
    defense: calcRealValueDeffenceDefencePokemon(pokemon),
    special_attack: calcRealValueSpecialAttackDefencePokemon(pokemon),
    special_defense: calcRealValueSpecialDeffenceDefencePokemon(pokemon),
    speed: calcRealValueSpeedDefencePokemon(pokemon),
  };

  statCache.set(cacheKey, effectiveValue);
  return effectiveValue;
}
